<template>
  <div class="card">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">
          <i class="fas fa-globe"></i>
          {{ $t('pages.market_overview') }}
        </h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :parentpage="{'name' : 'market', 'title': $t('pages.market')}"
            :page="$t('pages.market_overview')" />
        </div>
      </div>
    </div>
    <div>
      <div class="card-body">
        <ul class="nav nav-tabs customtab" role="tablist">
          <li class="nav-item">
            <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'bIndicator' }"
              @click="() => onSelectedTab('bIndicator')">
              <i class="fas fa-bold"></i>
              <span class="hidden-sm-up"> {{ $t('indicators.buffett') }}</span>
              <span class="hidden-xs-down"> {{ $t('indicators.buffett') }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'cap2Bond' }"
              @click="() => onSelectedTab('cap2Bond')">
              <i class="fas fa-money-bill-1-wave"></i>
              <span class="hidden-sm-up"> {{ $t('indicators.s2b') }}</span>
              <span class="hidden-xs-down"> {{ $t('indicators.s2b') }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'cap2Interest' }"
              @click="() => onSelectedTab('cap2Interest')">
              <i class="fas fa-landmark"></i>
              <span class="hidden-sm-up"> Interest</span>
              <span class="hidden-xs-down"> Interest</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'cap2Inflation' }"
              @click="() => onSelectedTab('cap2Inflation')">
              <i class="fas fa-money-bill-trend-up"></i>
              <span class="hidden-sm-up"> Inflation</span>
              <span class="hidden-xs-down"> Inflation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link cursor-pointer" :class="{ active: this.selectedTab === 'cap2Unemployment' }"
              @click="() => onSelectedTab('cap2Unemployment')">
              <i class="fas fa-building-user"></i>
              <span class="hidden-sm-up"> Unemployment</span>
              <span class="hidden-xs-down"> Unemployment</span>
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <!-- Cap2Unemployment -->
          <div class="tab-pane m-t-20" :class="{ active: this.selectedTab === 'cap2Unemployment' }">
            <el-select class="w-100 col-md-3 col-sm-3" v-model="periodCap2Unemployment" clearable
              @change="fetchMacroCharts('cap2Unemployment')">
              <el-option v-for="item in periodOptions" :key="item.code" :label="item.name" :value="item.code">
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
            <div>
              <loading-container :loading="form.cap2UnemploymentChartLoading">
                <div class="align-items-center m-t-20 m-b-20 p-positive">
                  <div class="summary">
                    <p>
                      Current / Average:
                      <span>
                        <strong>
                          {{ this.latestCap2Unemployment }}
                        </strong>
                        /
                        <strong>
                          {{ this.avgCap2Unemployment }}
                        </strong>
                      </span>
                    </p>
                    <div class="mt-3" v-if="this.latestCap2Unemployment > this.avgCap2Unemployment">
                      <p>
                        Risk: <span class="status-box negative">High</span>
                      </p>
                      <p>
                        Action: <span class="status-box positive">Conservative</span>
                      </p>
                    </div>
                    <div class="mt-3" v-else>
                      <p>
                        Risk: <span class="status-box positive">Low</span>
                      </p>
                      <p>
                        Action: <span class="status-box negative">Aggressive</span>
                      </p>
                    </div>
                  </div>
                  <div v-if="cap2UnemploymentChart">
                    <apexchart type="line" height="350" :options="cap2UnemploymentChart.chartOptions"
                      :series="cap2UnemploymentChart.series">
                    </apexchart>
                  </div>
                </div>
              </loading-container>
            </div>
          </div>

          <!-- Cap2Inflation -->
          <div class="tab-pane m-t-20" :class="{ active: this.selectedTab === 'cap2Inflation' }">
            <el-select class="w-100 col-md-3 col-sm-3" v-model="periodCap2Inflation" clearable
              @change="fetchMacroCharts('cap2Inflation')">
              <el-option v-for="item in periodOptions" :key="item.code" :label="item.name" :value="item.code">
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
            <div>
              <loading-container :loading="form.cap2InflationChartLoading">
                <div class="align-items-center m-t-20 m-b-20 p-positive">
                  <div class="summary">
                    <p>
                      Current / Average:
                      <span>
                        <strong>
                          {{ this.latestCap2Inflation }}
                        </strong>
                        /
                        <strong>
                          {{ this.avgCap2Inflation }}
                        </strong>
                      </span>
                    </p>
                    <div class="mt-3" v-if="this.latestCap2Inflation > this.avgCap2Inflation">
                      <p>
                        Risk: <span class="status-box negative">High</span>
                      </p>
                      <p>
                        Action: <span class="status-box positive">Conservative</span>
                      </p>
                    </div>
                    <div class="mt-3" v-else>
                      <p>
                        Risk: <span class="status-box positive">Low</span>
                      </p>
                      <p>
                        Action: <span class="status-box negative">Aggressive</span>
                      </p>
                    </div>
                  </div>
                  <div v-if="cap2InflationChart">
                    <apexchart type="line" height="350" :options="cap2InflationChart.chartOptions"
                      :series="cap2InflationChart.series" />
                  </div>
                </div>
              </loading-container>
            </div>
          </div>

          <!-- Cap2Bond -->
          <div class="tab-pane" :class="{ active: this.selectedTab === 'cap2Bond' }">
            <div class="mt-2">
              <el-select class="w-100 col-md-3 col-sm-3" v-model="periodCap2Bond" clearable
                @change="fetchMacroCharts('cap2Bond')">
                <el-option v-for="item in periodOptions" :key="item.code" :label="item.name" :value="item.code">
                  <span>{{ item.name }}</span>
                </el-option>
              </el-select>
            </div>
            <loading-container :loading="form.cap2BondChartLoading">
              <div class="same-row">
                <div class="align-items-center m-t-20 m-b-20 p-positive col-md-12 col-lg-12">
                  <div id="cap2BondChart">
                    <apexchart type="line" height="350" :options="cap2BondChart.chartOptions"
                      :series="cap2BondChart.series"></apexchart>
                  </div>
                </div>
              </div>
            </loading-container>
          </div>

          <!-- Buffett's Indicator -->
          <div class="tab-pane m-t-20" :class="{ active: this.selectedTab === 'bIndicator' }">
            <el-select class="w-100 col-md-3 col-sm-3" v-model="periodCap2GDP" clearable
              @change="fetchMacroCharts('cap2GDP')">
              <el-option v-for="item in periodOptions" :key="item.code" :label="item.name" :value="item.code">
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
            <div>
              <loading-container :loading="form.cap2GDPChartLoading">
                <div class="align-items-center m-t-20 m-b-20 p-positive">
                  <div class="summary">
                    <p>
                      Current / Average:
                      <span>
                        <strong>
                          {{ this.latestCap2GDP | percentDisplay }}
                        </strong>
                        /
                        <strong>
                          {{ this.avgCap2GDP | percentDisplay }}
                        </strong>
                      </span>
                    </p>
                    <div class="mt-3" v-if="this.latestCap2GDP > this.avgCap2GDP">
                      <p>
                        Risk: <span class="status-box negative">High</span>
                      </p>
                      <p>
                        Action: <span class="status-box positive">Conservative</span>
                      </p>
                    </div>
                    <div class="mt-3" v-else>
                      <p>
                        Risk: <span class="status-box positive">Low</span>
                      </p>
                      <p>
                        Action: <span class="status-box negative">Aggressive</span>
                      </p>
                    </div>
                  </div>
                  <div v-if="cap2GDPChart">
                    <apexchart type="line" height="350" :options="cap2GDPChart.chartOptions"
                      :series="cap2GDPChart.series">
                    </apexchart>
                  </div>
                </div>
              </loading-container>
            </div>
          </div>

          <!-- Cap2Interest -->
          <div class="tab-pane m-t-20" :class="{ active: this.selectedTab === 'cap2Interest' }">
            <el-select class="w-100 col-md-3 col-sm-3" v-model="periodCap2Interest" clearable
              @change="fetchMacroCharts('cap2Interest')">
              <el-option v-for="item in periodOptions" :key="item.code" :label="item.name" :value="item.code">
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
            <div>
              <loading-container :loading="form.cap2InterestChartLoading">
                <div class="align-items-center m-t-20 m-b-20 p-positive">
                  <div class="summary">
                    <p>
                      Current / Average:
                      <span>
                        <strong>
                          {{ this.latestCap2Interest }}
                        </strong>
                        /
                        <strong>
                          {{ this.avgCap2Interest }}
                        </strong>
                      </span>
                    </p>
                    <div class="mt-3" v-if="this.latestCap2Interest > this.avgCap2Interest">
                      <p>
                        Risk: <span class="status-box negative">High</span>
                      </p>
                      <p>
                        Action: <span class="status-box positive">Conservative</span>
                      </p>
                    </div>
                    <div class="mt-3" v-else>
                      <p>
                        Risk: <span class="status-box positive">Low</span>
                      </p>
                      <p>
                        Action: <span class="status-box negative">Aggressive</span>
                      </p>
                    </div>
                  </div>
                  <div v-if="cap2InterestChart">
                    <apexchart type="line" height="350" :options="cap2InterestChart.chartOptions"
                      :series="cap2InterestChart.series" />
                  </div>
                </div>
              </loading-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/Common/Breadcrumb";
import LoadingContainer from "@/components/Misc/LoadingContainer";
import common from "@/libs/common";

export default {
  name: "Market",
  components: {
    Breadcrumb,
    LoadingContainer
  },
  beforeMount() {
    this.getCap2GDPChart(this.sectorPeriod);
    if (!this.sectors.length) {
      this.getSectors();
    }
    this.fetchSectorIndexes();
  },
  data() {
    return {
      selectedTab: "bIndicator",
      sectorSelectedTab: 'sectorIndexes',
      sectorCode: 'ENE',
      industryCode: '',
      sectorPeriod: 'annual',
      periodCap2Bond: 'annual',
      periodCap2GDP: 'annual',
      periodCap2Interest: 'annual',
      periodCap2Inflation: 'annual',
      periodCap2Unemployment: 'annual'
    };
  },
  computed: {
    ...mapGetters({
      loading: "market/loading",
      form: "market/form",
      cap2BondChart: "market/cap2BondChart",
      sectorIndexChart: "market/sectorIndexChart",
      industryIndexChart: "market/industryIndexChart",
      industryComponentsChart: "market/industryComponentsChart",
      avgBI: "market/avgBI",
      latestBI: "market/latestBI",
      cap2GDPChart: "market/cap2GDPChart",
      avgCap2GDP: "market/avgCap2GDP",
      latestCap2GDP: "market/latestCap2GDP",
      cap2InterestChart: "market/cap2InterestChart",
      avgCap2Interest: "market/avgCap2Interest",
      latestCap2Interest: "market/latestCap2Interest",
      cap2InflationChart: "market/cap2InflationChart",
      avgCap2Inflation: "market/avgCap2Inflation",
      latestCap2Inflation: "market/latestCap2Inflation",
      cap2UnemploymentChart: "market/cap2UnemploymentChart",
      avgCap2Unemployment: "market/avgCap2Unemployment",
      latestCap2Unemployment: "market/latestCap2Unemployment",
      commonLoading: "common/loading",
      commonForm: "common/form",
      sectors: "common/sectors",
      industries: "common/industries",
    }),
    dailyOptions() {
      return common.getDailyOptions();
    },
    monthlyOptions() {
      return common.getMonthlyOptions();
    },
    periodOptions() {
      return common.getPeriodOptions();
    },
    filterSectorOptions() {
      return this.sectors;
    },
    filterIndustryOptions() {
      return this.industries;
    },
  },
  methods: {
    ...mapActions({
      setField: "market/setField",
      getBIndicator: "market/getBIndicator",
      getCap2BondChart: "market/getCap2BondChart",
      getSectorIndexes: "market/getSectorIndexes",
      getIndustryComponents: "market/getIndustryComponents",
      getIndustryIndexes: "market/getIndustryIndexes",
      getCap2GDPChart: "market/getCap2GDPChart",
      getCap2InterestChart: "market/getCap2InterestChart",
      getCap2InflationChart: "market/getCap2InflationChart",
      getCap2UnemploymentChart: "market/getCap2UnemploymentChart",
      getIndustries: "common/getIndustries",
      getSectors: "common/getSectors",
    }),
    fetchIndustryIndexes() {
      if (this.sectorCode && this.industryCode) {
        let params = {
          'period': this.sectorPeriod,
          'sector': this.sectorCode,
          'industryCode': this.industryCode
        }
        this.getIndustryIndexes(params);
        this.getIndustryComponents(this.industryCode);
      } else {
        let params = {
          'period': this.sectorPeriod,
          'sector': this.sectorCode,
          'industryCode': ''
        }
        this.getIndustryIndexes(params);
      }
    },
    fetchSectorIndexes() {
      this.industryCode = '';
      if (this.sectorCode) {
        this.getIndustries(this.sectorCode);
        let params = {
          'period': this.sectorPeriod,
          'sector': this.sectorCode
        }
        this.getSectorIndexes(params);
        this.getIndustryIndexes(params);
      } else {
        let params = {
          'period': this.sectorPeriod,
          'sector': ''
        }
        this.getSectorIndexes(params);
      }
    },
    getSectorIcons(code) {
      return common.getSectorIcons(code);
    },
    getSectorText(code) {
      return common.getSectorText(code);
    },
    fetchMacroCharts(type) {
      let period = '';
      switch (type) {
        case 'cap2Unemployment':
          period = this.periodCap2Unemployment;
          this.getCap2UnemploymentChart(period);
          break;
        case 'cap2Interest':
          period = this.periodCap2Interest;
          console.log("Period: " + period);
          this.getCap2InterestChart(period);
          break;
        case 'cap2Inflation':
          period = this.periodCap2Inflation;
          this.getCap2InflationChart(period);
          break;
        case 'cap2Bond':
          period = this.periodCap2Bond;
          this.getCap2BondChart(period);
          break;
        default:
          period = this.periodCap2GDP;
          this.getCap2GDPChart(period);
          break;
      }
    },
    onChangeS2BChart() {
      let period = 12;
      if (this.s2bChartPeriod) {
        period = this.s2bChartPeriod;
      } else {
        this.s2bChartPeriod = 12;
      }
      this.getS2BIndicator(period);
    },
    onChangeBChart() {
      let period = 12;
      if (this.bChartPeriod) {
        period = this.bChartPeriod;
      } else {
        this.bChartPeriod = 12;
      }
      this.getBIndicator(period);
    },
    collapseSidebar(key) {
      this.setField({ key: key, value: !this.form[key] });
    },
    onSelectedTab(type) {
      this.selectedTab = type;
      this.fetchMacroCharts(type);
    },
    onSectorSelectedTab(type) {
      this.sectorSelectedTab = type;
      switch (type) {
        case 'sectorIndexes':
          this.fetchSectorIndexes();
          break;
        case 'sectorInventory':
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
.summary p {
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.ti-close {
  position: absolute;
  right: -12px;
  top: -13px;
  font-weight: bold;
  background: #fff;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
  opacity: 0.5;
  transition: ease-in;
}

.ti-close:hover {
  opacity: 1;
  transition: ease-in;
}

.bg-gray {
  background-color: #ddd;
}

td small {
  vertical-align: super;
}

.th-sort {
  position: relative;
  vertical-align: top;
  cursor: pointer;
}

.descending:after {
  content: "\2193";
}

.ascending:after {
  content: "\2191";
}

.ascending:after,
.descending:after {
  display: inline-block;
}
</style>
